import { Box, Typography, Link } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { themeUtils } from '../../../theme';

const DEMO_URL = 'https://easycheckpro.com/demo';
const WHATSAPP_NUMBER = '971589660220';

// Prefilled WhatsApp message varies slightly by where the user is in signup.
const WHATSAPP_MESSAGES = {
  signup: "Hi! I'm signing up for EasyCheck and have a question.",
  payment: "Hi! I'm choosing an EasyCheck plan and have a question.",
};

const linkSx = {
  color: themeUtils.colors.blue['blue-600'],
  textDecoration: 'none',
  fontWeight: 600,
  '&:hover': {
    textDecoration: 'underline',
    color: themeUtils.colors.blue['blue-700'],
  },
};

/**
 * Subtle secondary help row shown on the signup contact form and the payment step.
 * Gives hesitant users a low-commitment alternative (book a demo / chat on WhatsApp)
 * at the two highest drop-off points without competing with the primary CTA.
 */
const SignupHelpLinks = ({ stage = 'signup' }) => {
  const message = WHATSAPP_MESSAGES[stage] || WHATSAPP_MESSAGES.signup;
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        mt: 2,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Have questions?
      </Typography>
      <Link href={DEMO_URL} target="_blank" rel="noopener" variant="body2" sx={linkSx}>
        Book a demo
      </Link>
      <Typography variant="body2" color="text.secondary">
        ·
      </Typography>
      <Link
        href={whatsappUrl}
        target="_blank"
        rel="noopener"
        variant="body2"
        sx={{ ...linkSx, display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
      >
        <WhatsApp fontSize="small" sx={{ color: '#25D366' }} />
        Chat on WhatsApp
      </Link>
    </Box>
  );
};

export default SignupHelpLinks;
